import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { LOGOS, ANATOMY_CALLOUTS } from "../../data/site";
import { revealUp, staggerParent, viewportOnce, EASE } from "../../lib/motion";

export const AnatomyOfMark = () => {
  const [active, setActive] = useState(null);
  const reduce = useReducedMotion();

  return (
    <section data-testid="story-anatomy" className="py-4 sm:py-6">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="w-full rounded-[28px] bg-inkred px-6 py-16 sm:px-12 sm:py-24">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            variants={staggerParent}
            className="text-center"
          >
            <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
              03 / ANATOMY OF THE MARK
            </motion.p>
            <motion.h2 variants={revealUp} className="font-display text-3xl leading-[1.1] tracking-tight text-labyellow sm:text-5xl">
              EVERY LINE IS A DECISION.
            </motion.h2>

            <motion.img
              variants={revealUp}
              src={LOGOS.yellow}
              alt="Chicken Labb mark"
              className="mx-auto mt-12 h-52 w-auto sm:h-64"
            />
          </motion.div>

          {/* Annotation columns */}
          <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-10 md:grid-cols-3 md:gap-10">
            {ANATOMY_CALLOUTS.map((c, i) => {
              const isActive = active === c.id;
              const color = isActive ? "#EC2027" : "#FDBC1F";
              return (
                <motion.div
                  key={c.id}
                  data-testid={`anatomy-callout-${c.id}`}
                  onMouseEnter={() => setActive(c.id)}
                  onMouseLeave={() => setActive(null)}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={viewportOnce}
                  transition={{ duration: 0.5, delay: reduce ? 0 : 0.15 + i * 0.15 }}
                  className="flex cursor-default flex-col items-center text-center"
                >
                  <span className="h-2.5 w-2.5 rounded-full transition-colors" style={{ backgroundColor: color }} />
                  <motion.span
                    className="mt-1 block w-px origin-top"
                    style={{ height: 48, backgroundColor: color }}
                    initial={{ scaleY: reduce ? 1 : 0 }}
                    whileInView={{ scaleY: 1 }}
                    viewport={viewportOnce}
                    transition={{ duration: reduce ? 0 : 0.5, ease: EASE, delay: reduce ? 0 : 0.3 + i * 0.15 }}
                  />
                  <span className="mt-5 font-mono text-3xl font-medium" style={{ color }}>
                    {`0${i + 1}`}
                  </span>
                  <p className={`mt-3 font-mono text-[11px] uppercase tracking-[0.25em] transition-colors ${isActive ? "text-labred" : "text-labyellow"}`}>
                    {c.label}
                  </p>
                  <p className={`mt-3 max-w-xs font-body text-sm leading-relaxed transition-colors ${isActive ? "text-paper" : "text-paper/70"}`}>
                    {c.copy}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
